<div class="risk-summary" [ngClass]="classes">
	<p class="risk-summary__title mb-20">{{ titleKey | translate }}</p>
	<p>{{ summaryKey | translate }}</p>
	<a [href]="getUrl()" target="_blank" class="risk-summary__link">
		<strong>{{ "uk_finprom_risk_summary_warning_link" | translate }}</strong>
	</a>
</div>
